import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    data:[],
    isDeleting:null,
    status:null,
}

const token = userObj?.token

export const deleteVehicle = createAsyncThunk(
    'partner/deleteSelectedVehicle',
    async (id, {rejectWithValue}) => {
        
        try{
            const response = await axios.delete(`Partner/deleteVehicle/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const deleteVehicleSlice = createSlice({
    name: 'deleteVehicle',
    initialState,
    reducers: {},
    extraReducers:{
        [deleteVehicle.pending]: (state, action) => {
            state.status='pending';
            state.isDeleting=true;
        },
        [deleteVehicle.fulfilled]: (state, action) => {
            state.status='success';
            state.isDeleting=false;
            state.data = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [deleteVehicle.rejected]: (state, action) => {
            state.status='failed';
            state.isDeleting=false;
        }
    }
})

export default deleteVehicleSlice.reducer;